import React, { useState, useEffect, useCallback, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import {
  Card,
  Grid,
  TextField,
  Button,
  IconButton,
  ButtonGroup,
  Typography,
  InputAdornment,
  Dialog,
  Paper,
  DialogContent,
  DialogActions,
  Divider,
} from "@material-ui/core";
import useReactRouter from "use-react-router";
import { LangContext } from "../../../Context/Langcontext";
import { useSnackbar } from "notistack";
import TableData from "../../Item/TableData";
import { getPaymentUserList, addPayment } from "../../../API/paymentApi";
import { ServiceContext } from "../../../Context/ServiceContext";
import { IoMdClose } from "react-icons/io";
import { FaSort } from "react-icons/fa";
import { AiOutlineLine } from "react-icons/ai";
const useStyle = makeStyles((theme) => ({
  root: {
    width: "99.5%",
    minHeight: "-webkit-fill-available",
  },
  cardapi: {
    width: "100%",
    backgroundColor: "#FFFFFF",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    borderRadius: 8,
    marginTop: "0.5rem",
    marginBottom: "0.1rem",
    // minHeight: "100%",
    // maxHeight: "auto",
    minHeight: "calc(100vh - 17.9rem)",
    maxHeight: "100%",
  },
  addbtn: {
    borderRadius: 8,
    padding: "0.4rem 2rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#E16733",
    color: "#FFFFFF",
    "&:hover": {
      background: "#E16733",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
    lineHeight: 2,
  },
  textfield: {
    "& .MuiOutlinedInput-input": {
      padding: "14px 14px",
      fontWeight: 200,
    },
  },
  input: {
    fontSize: "1.2rem",
    fontWeight: 200,
    color: "#595A5A",
    marginLeft: "1rem",
  },
  creditnumber: {
    fontWeight: 700,
    color: "#595A5A",
    fontSize: "1.5rem",
  },
  select: {
    fontSize: "1.2rem",
    fontWeight: 200,
    color: "#595A5A",
  },
  unit: {
    fontSize: "1.2rem",
    fontWeight: 200,
    color: "#595A5A",
    marginLeft: "1rem",
  },

  iconbtn: {
    padding: 6,
  },
  activebtn: {
    padding: "0.5rem 4rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#595a5a",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#595a5a",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  nonactive: {
    padding: "0.5rem 4rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#9b9b9b",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#9b9b9b",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  cardcredit: {
    boxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 5px 0px rgba(191,192,191,1)",
    width: "100%",
    height: "5rem",
    display: "flex",
    alignItems: "center",
  },
  btngroup: {
    "& .MuiButtonGroup-groupedContainedHorizontal:not(:last-child)": {
      borderRight: "unset",
    },
  },
  btnstylesubmit: {
    borderRadius: 8,
    padding: "0.4rem 2rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#E16733",
    color: "#FFFFFF",
    "&:hover": {
      background: "#e16733",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  btnstylecancel: {
    borderRadius: 8,
    padding: "0.4rem 2rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#BFC0BF",
    color: "#595A5A",
    "&:hover": {
      background: "#BFC0BF",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  paper: {
    backgroundColor: "#E16733",
    borderRadius: 4,
    height: "4rem",
    display: "flex",
    alignItems: "center",
    boxShadow: "unset",
    justifyContent: "space-between",
  },
  dialog: {
    "& .MuiDialog-paperFullWidth": { borderRadius: 10 },
    "& .MuiDialogContent-root:first-child": {
      paddingTop: 10,
    },
  },
  headtext: {
    fontSize: "1.2rem",
    color: "#faf7f1",
    fontWeight: 200,
    marginLeft: "2.5rem",
  },
  closeicon: {
    color: "#faf7f1",
  },
  icnclose: {
    marginRight: "2rem",
  },
  btndis: {
    borderRadius: 8,
    padding: "0.5rem 2rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#ebebeb",
    color: "#FFFFFF",
  },
  cffont: {
    fontSize: "1.2rem",
    fontWeight: 700,
    color: "#595A5A",
    marginBottom: "1rem",
  },
  cf2font: {
    fontSize: "1.2rem",
    fontWeight: 200,
    color: "#595A5A",
    marginBottom: "1rem",
  },
}));
const AddcreditUser = ({ create, setCreate }) => {
  const classes = useStyle();
  const { history, match } = useReactRouter();
  const [data, setData] = useState([]);
  const [fetch, setfetch] = useState(false);
  const serviceContext = useContext(ServiceContext);
  const [state, setState] = useState({ insert: "", credit: 0 });
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);

  const columns = [
    {
      title: (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Typography style={{ fontWeight: 400 }}>{lang.Date}</Typography>
          <AiOutlineLine style={{ transform: "rotate(90deg)" }} />
        </div>
      ),
      field: "date",
      headerStyle: {
        textAlign: "left",
      },
      cellStyle: {
        textAlign: "left",
        borderRight: "1px solid #e0e0e0",
      },
      sorting: true,
      customSort: (a, b) => (a.time > b.time ? 1 : -1),
      icons: {
        SortArrow: React.forwardRef((props, ref) => (
          <FaSort {...props} ref={ref} />
        )),
      },
    },
    {
      width: 100,
      title: `${lang.Amount} (${lang.THB})`,
      field: "amount",
      headerStyle: {
        textAlign: "right",
      },
      cellStyle: {
        textAlign: "right",
      },
      sorting: false,
    },
  ];

  const convertDate = (d) => {
    const monthNames = [
      lang.January,
      lang.February,
      lang.March,
      lang.April,
      lang.May,
      lang.June,
      lang.July,
      lang.August,
      lang.September,
      lang.October,
      lang.November,
      lang.December,
    ];

    let dateObj = new Date(d);
    let month = monthNames[dateObj.getMonth()];
    let day = String(dateObj.getDate()).padStart(2, "0");
    let year = dateObj.getFullYear();

    let output = `${day} ${month} ${
      langContext.lang.locale === "th" ? Number(year + 543) : year
    }`;
    return output;
  };

  const Rows = data
    .sort((a, b) => (a.created_at > b.created_at ? -1 : 1))
    .map((rs) => {
      return {
        time: rs.created_at,
        date: convertDate(rs.created_at),
        amount: rs.total.toLocaleString(),
      };
    });

  const getData = useCallback(async () => {
    const get = await getPaymentUserList(match.params.id);

    let total = 0;
    if (get.status.code === 200 && get.data.length !== 0) {
      setData(get.data);

      get.data.map((d) => {
        return (total = total + d.total);
      });
    }
    const user = serviceContext.sum.find((rs) => {
      return rs._id !== undefined ? rs._id.user_id === match.params.id : "";
    });
    const balance =
      user !== undefined
        ? Number(Number(total) - Number(user.sum_net))
        : Number(total);

    setState({ ...state, credit: balance, insert: "" });
  }, [state, match, serviceContext]);

  useEffect(() => {
    if (!fetch && serviceContext.sum.length !== 0) {
      getData();
      setfetch(true);
    }
  }, [fetch, serviceContext, getData]);

  const InsertCredit = async (e) => {
    e.preventDefault();
    setOpen(true);
  };

  const addCredit = async () => {
    let input = {
      type: "prepaid",
      total: Number(state.insert),
      user_id: match.params.id,
    };

    const add = await addPayment(input);
    if (add.status.code === 201) {
      setfetch(false);
      setOpen(false);
      enqueueSnackbar(lang.Addcreditssuccessfully, {
        variant: "success",
      });
    } else {
      enqueueSnackbar(lang.Error, {
        variant: "error",
      });
    }
  };

  const MyIcon = () => (
    <span>
      <FaSort />
    </span>
  );
  return (
    <div className={classes.root}>
      <Card className={classes.cardapi}>
        {match.params.id === "add" ? null : (
          <div style={{ backgroundColor: "#f4f4f4", width: "100%" }}>
            <ButtonGroup variant="contained" className={classes.btngroup}>
              <Button
                onClick={() => {
                  history.push(`/app/useradmin/user/${match.params.id}-null`);
                }}
                className={
                  match.params.payment !== "null"
                    ? classes.nonactive
                    : classes.activebtn
                }
              >
                {lang.UserProfile}
              </Button>
              <Button
                onClick={() => {
                  history.push(`/app/useradmin/user/${match.params.id}-credit`);
                }}
                className={
                  match.params.payment === "null"
                    ? classes.nonactive
                    : classes.activebtn
                }
              >
                {lang.AddCredit}
              </Button>
            </ButtonGroup>
          </div>
        )}
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ width: "100%", maxWidth: "85%" }}>
            <div style={{ margin: "2rem 2rem 0rem 2rem" }}>
              <Grid container>
                <Grid item xs={12}>
                  <Card className={classes.cardcredit}>
                    <Grid container>
                      <Grid
                        item
                        xs={8}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          alt="bath"
                          src={require("../../../images/graphic-icon/baht.png")}
                          style={{ height: "2.5rem", width: "auto" }}
                        />
                        <Typography className={classes.input}>
                          {lang.YourTotalCredits}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={4}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          className={classes.creditnumber}
                        >{`${state.credit.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}`}</Typography>
                        <Typography className={classes.unit}>
                          {lang.THB}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>

              <Grid
                container
                spacing={2}
                style={{ marginTop: "1rem" }}
                component="form"
                onSubmit={InsertCredit}
              >
                <Grid item xs={10}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    required
                    value={state.insert}
                    type="number"
                    placeholder={lang.InsertCredit}
                    className={classes.textfield}
                    onChange={(e) => {
                      if (e.target.value.startsWith("-")) {
                      } else {
                        setState({ ...state, insert: e.target.value });
                      }
                    }}
                    InputProps={{
                      inputProps: { min: 0 },
                      endAdornment: (
                        <InputAdornment position="end">
                          {lang.THB}
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    className={
                      state.insert !== "" ? classes.addbtn : classes.btndis
                    }
                    disabled={!state.insert}
                  >
                    {lang.Add}
                  </Button>
                </Grid>
              </Grid>
            </div>

            <TableData
              columns={columns}
              data={Rows}
              Iconsort={React.forwardRef((props, ref) => (
                <MyIcon {...props} ref={ref} />
              ))}
            />
          </div>
        </div>
      </Card>
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        aria-labelledby="form-dialog-title"
        maxWidth="sm"
        fullWidth={true}
        className={classes.dialog}
      >
        <Paper className={classes.paper}>
          <Typography className={classes.headtext}>{lang.AddCredit}</Typography>
          <IconButton
            className={classes.icnclose}
            onClick={() => {
              setOpen(false);
            }}
          >
            <IoMdClose className={classes.closeicon} size={20} />
          </IconButton>
        </Paper>
        <div style={{ margin: "1rem" }}>
          <DialogContent className={classes.content}>
            <Typography align="center" className={classes.cffont}>
              {langContext.lang.locale === "th"
                ? `${lang.DialogAddCredit} ${state.insert} ${lang.THB} ?`
                : `You want to add credit ${state.insert} Bath ?`}
            </Typography>

            <Typography align="center" className={classes.cf2font}>
              {lang.PleaseOk}
            </Typography>
            <Divider />
          </DialogContent>
          <DialogActions>
            <Button
              className={classes.btnstylecancel}
              onClick={() => {
                setOpen(false);
              }}
            >
              {lang.Cancel}
            </Button>
            <Button className={classes.btnstylesubmit} onClick={addCredit}>
              {lang.OK}
            </Button>
          </DialogActions>
        </div>
      </Dialog>
    </div>
  );
};

export default AddcreditUser;
